import { useState } from 'react'
import { useAngularServices } from '@/react/components'
import { CurrentUserType } from '@/react/types/documentation'

interface HoveredField {
  field__name: string
  text: string
  max__length: number
}

export const useEmployeeRowState = () => {
  const { CurrentUser } = useAngularServices()
  const variableColor = (CurrentUser as CurrentUserType).getClientSettings()
    .web_primary_color
  const [hoveredField, setHoveredField] = useState<HoveredField | null>(null)

  return {
    variableColor,
    hoveredField,
    setHoveredField,
  }
}
